import * as Dialog from '@radix-ui/react-dialog';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';

interface ModalDialogTriggerProps
  extends Omit<Dialog.DialogTriggerProps, 'className'>,
    ComponentProps<
      Omit<HTMLAttributes<HTMLButtonElement>, 'size' | 'className'>
    > {}

export const ModalDialogTrigger = forwardRef<
  HTMLButtonElement,
  ModalDialogTriggerProps
>(({ children, ...props }, ref) => {
  const className = getClassNameOverride(props, 'ModalDialog.Trigger');

  return (
    <Dialog.Trigger ref={ref} {...props} className={className} asChild>
      {children}
    </Dialog.Trigger>
  );
});

ModalDialogTrigger.displayName = 'ModalDialog.Trigger';
